module.exports = __webpack_public_path__ + "img/0002.6610c654.jpg";